/**
 * @fileoverview gRPC-Web generated client stub for csvexporter.private.creditnotes
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as credit_notes_pb from './credit_notes_pb';


export class CreditNotesExporterServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'text';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorExportCreditNotes = new grpcWeb.MethodDescriptor(
    '/csvexporter.private.creditnotes.CreditNotesExporterService/ExportCreditNotes',
    grpcWeb.MethodType.UNARY,
    credit_notes_pb.ExportCreditNotesRequest,
    credit_notes_pb.ExportResponse,
    (request: credit_notes_pb.ExportCreditNotesRequest) => {
      return request.serializeBinary();
    },
    credit_notes_pb.ExportResponse.deserializeBinary
  );

  exportCreditNotes(
    request: credit_notes_pb.ExportCreditNotesRequest,
    metadata: grpcWeb.Metadata | null): Promise<credit_notes_pb.ExportResponse>;

  exportCreditNotes(
    request: credit_notes_pb.ExportCreditNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: credit_notes_pb.ExportResponse) => void): grpcWeb.ClientReadableStream<credit_notes_pb.ExportResponse>;

  exportCreditNotes(
    request: credit_notes_pb.ExportCreditNotesRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: credit_notes_pb.ExportResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/csvexporter.private.creditnotes.CreditNotesExporterService/ExportCreditNotes',
        request,
        metadata || {},
        this.methodDescriptorExportCreditNotes,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/csvexporter.private.creditnotes.CreditNotesExporterService/ExportCreditNotes',
    request,
    metadata || {},
    this.methodDescriptorExportCreditNotes);
  }

}

